import { lazy } from 'react'
export * from './Landing'
export * from './Layout/Layout'

const Banquet = lazy(() => import('./Banquet/Banquet'))

export { Banquet }
